import { Button } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import fileDownload from 'js-file-download';
import { NoDataDash } from '../../../../../components/formatters';
import { SearchDocumentsDto } from '../../../../../services/dtos/securities/searchDocuments.dto';
import { fetchBondDocument, fetchLoanDocument } from '../../../../../services/securities/securities.service';
import { removeDateFromDocumentTitle } from '../../CompanyDocumentsTab.logic';
import { GroupedTableRowRendererProps } from '../../GroupedTableRow/GroupedTableRow.types';
import styles from './DocumentNameRenderer.module.scss';

const cx = classNames.bind(styles);

const DocumentNameRenderer = ({
  data,
  columnConfig,
  tableConfig,
  row: { isHovered, isDisabled },
}: GroupedTableRowRendererProps<SearchDocumentsDto>): React.ReactElement => {
  const downloadDocument = async (document: SearchDocumentsDto, documentName: string) => {
    const apiFileName = document.document!;
    const nameFileAs = `${documentName}.${apiFileName.split('.').at(-1)}`;
    if ('borrower_legal_name' in document) {
      const blob = await fetchLoanDocument(apiFileName);
      fileDownload(blob, nameFileAs);
    } else {
      const blob = await fetchBondDocument(apiFileName);
      fileDownload(blob, nameFileAs);
    }
  };

  const renderDocumentFile = () => {
    const documentResourceLocation = data.document;
    const documentName = removeDateFromDocumentTitle(data[columnConfig.dataKey]);
    const isDocumentResourceLocationLink = documentResourceLocation?.startsWith('http');

    if (!documentResourceLocation && !documentName) {
      return <NoDataDash />;
    }

    if (!documentResourceLocation) {
      return <span className={cx('document-title')}>{documentName}</span>;
    }

    return isDocumentResourceLocationLink ? (
      <a href={documentResourceLocation} target="_blank" rel="noreferrer">
        {documentName}
      </a>
    ) : (
      <Button className={cx('document-btn')} onClick={() => downloadDocument(data, documentName)}>
        <span>{documentName}</span>
      </Button>
    );
  };
  const key = tableConfig.getRowKey(data);
  return (
    <div key={key} className={cx('body', { 'gray-out': isHovered && isDisabled })}>
      {renderDocumentFile()}
    </div>
  );
};

export default DocumentNameRenderer;
